import type * as React from "react";
import { Box, type SxProps, type Theme } from "~/common/mui";
import { ActionIconButton, ActionIconButtonType } from "~/common/components/Button/ActionIconButton";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import Modal from "~/common/components/Modal";
import classNames from "classnames";
import LanguageAwareExternalContent from "~/features/configurator/Linear/components/LanguageAwareExternalContent";
import InfoIcon from "@mui/icons-material/Info";

interface InfoBallProps {
  className?: string;
  onClick: (e: React.MouseEvent) => void;
  sx?: SxProps<Theme>;
}
export const InfoBall = ({ className, onClick, sx }: InfoBallProps) => {
  return (
    <Box sx={{ cursor: "pointer", pointerEvents: "all", ...sx }}>
      <ActionIconButton
        clickableType={ActionIconButtonType.SECONDARY}
        icon={<InfoIcon sx={{ fontSize: 20 }} />}
        className={classNames("scha__info-ball", className)}
        onClick={onClick}
      />
    </Box>
  );
};

interface Props {
  className?: string;
  popupClassName?: string;
  info?: string;
}

const LinearInfo = ({ info, className, popupClassName }: Props) => {
  const { val: modalOpen, setTrue, setFalse } = useBooleanState(false);

  if (!info) {
    return null;
  }

  const openModal = (e: React.MouseEvent) => {
    setTrue();
    e.stopPropagation();
    e.preventDefault();
  };

  const closeModal = (e: React.MouseEvent) => {
    setFalse();
    e.stopPropagation();
    e.preventDefault();
  };

  let extraClasses = "";
  if (isUrl(info)) {
    const params = new URLSearchParams(info.split("?")[1]);
    extraClasses = params.getAll("modalCls").join(" ");
  }

  return (
    <>
      <InfoBall
        className={classNames("scha__linear__configurator__info-ball", className)}
        onClick={openModal}
        sx={{ color: "text.primary", ml: 1 }}
      />
      {modalOpen && (
        <Modal onClose={closeModal} modalClassName={classNames(popupClassName, extraClasses)}>
          <LanguageAwareExternalContent content={info} />
        </Modal>
      )}
    </>
  );
};
export default LinearInfo;

const isUrl = (val: string) => val.startsWith("http");
